/**
 * This error is for when an appointment is cancelled/removed and expected
 * to be replaced with a new appointment, but the API returned a
 * partial response (status code: 206), meaning the original appointment
 * was cancelled, but the new appointment that was supposed to replace it
 * failed to be created.
 */
export class AppointmentReplacementPartialFailedError extends Error {
  constructor(message: string) {
    super(message);

    this.name = 'AppointmentReplacementPartialFailedError';
  }
}
